/* eslint-disable import/prefer-default-export */

export function fixerPhotoUrl(fixer) {
  const fixerPhotoBaseUrl = 'https://d28qlhsxke0kms.cloudfront.net';
  return `${fixerPhotoBaseUrl}/${fixer.photo_id}`;
}
